import { render, staticRenderFns } from "./ChoiceRejectPayment.vue?vue&type=template&id=85142334&"
import script from "./ChoiceRejectPayment.vue?vue&type=script&lang=js&"
export * from "./ChoiceRejectPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85142334')) {
      api.createRecord('85142334', component.options)
    } else {
      api.reload('85142334', component.options)
    }
    module.hot.accept("./ChoiceRejectPayment.vue?vue&type=template&id=85142334&", function () {
      api.rerender('85142334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/services/payments/ChoiceRejectPayment.vue"
export default component.exports